exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5827106b] .el-dialog {\n  border-radius: 8px;\n}\n[data-v-5827106b] .el-dialog__body {\n  padding: 5px 20px;\n}\n.logout-tip-title[data-v-5827106b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #303133;\n  font-size: 16px;\n  font-weight: 500;\n}\n.logout-tip-content[data-v-5827106b] {\n  font-size: 14px;\n  color: #606266;\n}", ""]);

// exports
